// 关于登录状态
export const USER_SIGNIN = 'USER_SIGNIN' // 登录成功
export const USER_SIGNOUT = 'USER_SIGNOUT' // 退出登录

// 关于二维码标签管理
export const QR_LABEL_LIST_INIT = 'QR_LABEL_LIST_INIT' // 初始化二维码标签列表
export const QR_LABEL_ADD_ONE = 'QR_LABEL_ADD_ONE'  // 添加一个新的标签
export const QR_LABEL_DELETE_ONE = 'QR_LABEL_DELETE_ONE' // 删除一个标签
export const QR_LABEL_UPDATE_ONE = 'QR_LABEL_UPDATE_ONE'  // 更新一个标签
